import { LOCALE_DEFAULT } from '@growtherapy/i18n';
import { SproutCoreResources } from '@growtherapy/sprout-ui';

import { SeedlingsCoreResources } from '@grow-therapy-team/seedling-components';

import telehealthCoreEn from './en/telehealth-core.json';

export * from './Translate';
export const NS_TELEHEALTH_CORE = 'telehealth-core';

const telehealthCoreResouces = {
  [NS_TELEHEALTH_CORE]: telehealthCoreEn,
  ...SeedlingsCoreResources,
  ...SproutCoreResources,
};

export const telehealthCoreResoucesEn = {
  [LOCALE_DEFAULT]: telehealthCoreResouces,
};
